/**
 * Contesto dell'alberatura dell'ente.
 *
 * L'alberatura serve a quasi ogni pagina del back-office — cruscotto, filtri
 * delle pubblicazioni, alberatura, scadenzario, pannello di conformita' — e cambia
 * solo quando il super admin la modifica. Caricarla una volta nel guscio
 * dell'applicazione, invece che in ogni pagina, evita una decina di richieste
 * identiche e tiene allineate le denominazioni mostrate nelle diverse viste.
 */

import { createContext, useContext } from "react";
import type { ErroreApi } from "../api/client";
import type { Ente, Nodo } from "../api/types";

export interface ValoreAlberatura {
  ente: Ente | null;
  /** Le 22 sezioni di primo livello, con i figli annidati. */
  nodi: Nodo[];
  /**
   * Tutti i nodi appiattiti, **tutti e tre i livelli**: sezioni, sottosezioni e
   * obblighi. Sono i 219 dell'alberatura ANAC c1, non le sole 98 dei primi due
   * livelli: gli obblighi sono i nodi su cui si pubblica, e chi li cercasse qui
   * senza trovarli filtrerebbe le pubblicazioni su un elenco monco.
   */
  tuttiINodi: Nodo[];
  inCaricamento: boolean;
  errore: ErroreApi | null;
  /** Rilegge l'alberatura: da chiamare dopo una modifica ai nodi. */
  ricarica: () => void;
  /** Denominazione di un nodo dal suo identificativo, con ricaduta sull'id. */
  denominazione: (idNodo: string) => string;
}

export const ContestoAlberatura = createContext<ValoreAlberatura | null>(null);

export function useAlberatura(): ValoreAlberatura {
  const valore = useContext(ContestoAlberatura);
  if (!valore) throw new Error("useAlberatura va usato dentro <FornitoreAlberatura>.");
  return valore;
}
